import React from 'react';
import { LOGO } from '../../constants/site';

const LOGO_FILTER = 'brightness(0) invert(1) sepia(1) saturate(5) hue-rotate(180deg)';

export const FooterBrand = () => (
  <div className="flex flex-col items-center mb-12">
    <div className="relative">
      <div className="absolute -inset-10 bg-gradient-to-r from-gold-400/40 via-gold-500/30 to-gold-600/40 blur-3xl rounded-full animate-pulse"></div>
      <img src={LOGO} alt="Jess Sells East Coast" className="relative h-40 md:h-52 lg:h-64 w-auto drop-shadow-2xl" loading="lazy" decoding="async" style={{ filter: LOGO_FILTER, WebkitFilter: LOGO_FILTER }} />
    </div>
    <div className="mt-6 flex items-center space-x-2 bg-sand-50 rounded-lg px-3 py-2 shadow-lg">
      <svg className="w-5 h-5 text-red-600" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" /></svg>
      <div className="flex flex-col">
        <span className="text-[#143160] text-xs font-black tracking-tight">VETERANS UNITED</span>
        <span className="text-[#c41e3a] text-[11px] font-bold">Preferred Agent</span>
      </div>
    </div>
    <div className="mt-6 text-center">
      <h3 className="text-3xl md:text-4xl lg:text-5xl font-cursive font-bold text-white drop-shadow-2xl" style={{ letterSpacing: '0.05em', textShadow: '0 0 30px rgba(255,255,255,0.4), 0 4px 12px rgba(0,0,0,0.6)' }}>Jessica Burnette</h3>
      <p className="text-gold-400 font-semibold tracking-wide mt-2">REALTOR® | MRP®</p>
      <p className="text-white/60 text-sm mt-1">VA License #0225252447 | NC License #337285</p>
    </div>
  </div>
);
